import React from 'react';
import { Package, Coins, Printer } from 'lucide-react';

export function EquipmentCardsMockup() {
  const items = [
    {
      name: 'Lame du Vide',
      type: 'weapon',
      emoji: '⚔️',
      rarity: 'legendary',
      color: '#ff8000',
      glow: 'rgba(255,128,0,0.5)',
      bonus: '+3',
      effect: 'Inflige 2d6 dégâts nécrotiques. Critique sur 19-20.',
      slot: 'Main princ.',
      value: '28000',
      weight: '3',
      holo: true,
      pulse: true,
    },
    {
      name: 'Cape d\'Invisibilité',
      type: 'wondrous',
      emoji: '✨',
      rarity: 'very_rare',
      color: '#a335ee',
      glow: 'rgba(163,53,238,0.5)',
      bonus: null,
      effect: 'Action: Invisible jusqu\'à la fin du tour suivant.',
      slot: 'Dos',
      value: '12000',
      weight: '1',
      holo: true,
      pulse: false,
    },
    {
      name: 'Potion de Soin Sup.',
      type: 'potion',
      emoji: '🧪',
      rarity: 'rare',
      color: '#0070dd',
      glow: 'rgba(0,112,221,0.5)',
      bonus: null,
      effect: 'Restaure 8d4+8 points de vie.',
      slot: null,
      value: '500',
      weight: '0.5',
      holo: false,
      pulse: false,
      charges: '3/3',
    },
  ];

  const rarityLabels = {
    legendary: 'Légendaire',
    very_rare: 'Très rare',
    rare: 'Rare',
  };

  return (
    <div className="landing-mockup-card overflow-visible">
      <div className="flex items-center gap-2 mb-3 flex-wrap">
        <div className="flex items-center gap-1 text-[10px] px-2 py-1 rounded bg-primary/10 text-primary font-medium cursor-pointer">
          <Package className="h-3 w-3" /> Inventaire
        </div>
        <div className="flex items-center gap-1 text-[10px] px-2 py-1 rounded bg-muted/50 text-muted-foreground cursor-pointer hover:bg-muted">
          <Coins className="h-3 w-3" /> Générateur
        </div>
        <div className="ml-auto flex items-center gap-1">
          <div className="text-[9px] px-2 py-0.5 rounded bg-muted/50 text-muted-foreground flex items-center gap-1">
            <Printer className="h-2.5 w-2.5" /> Imprimer
          </div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2">
        {items.map((item, i) => (
          <div
            key={i}
            className="landing-ttrpg-card group relative"
            style={{
              '--rarity-color': item.color,
              '--rarity-glow': item.glow,
              animationDelay: `${i * 150}ms`,
            }}
          >
            <div className={`rounded-lg border-2 overflow-hidden bg-card/90 ${item.pulse ? 'landing-card-pulse' : ''}`} style={{ borderColor: item.color }}>
              <div className="h-14 bg-gradient-to-br from-muted/30 to-muted/60 flex items-center justify-center relative">
                <span className="text-2xl opacity-30">{item.emoji}</span>
                {item.charges && (
                  <span className="absolute top-1 right-1 text-[7px] font-mono px-1 py-0 rounded border bg-black/50" style={{ borderColor: item.color, color: item.color }}>
                    {item.charges}
                  </span>
                )}
                {item.holo && (
                  <div className="absolute inset-0 landing-holo-shimmer opacity-0 group-hover:opacity-60 transition-opacity" />
                )}
              </div>
              <div className="h-px mx-1.5 opacity-40" style={{ background: item.color }} />
              <div className="px-1.5 pt-1 flex items-center gap-1">
                <span className="font-cinzel text-[9px] font-bold truncate flex-1" style={{ color: item.color }}>{item.name}</span>
                {item.bonus && (
                  <span className="text-[8px] font-cinzel font-black px-1 rounded border bg-black/20" style={{ color: item.color, borderColor: item.color }}>
                    {item.bonus}
                  </span>
                )}
              </div>
              <div className="px-1.5 pb-0.5 flex justify-between text-[7px] text-muted-foreground">
                <span>{rarityLabels[item.rarity]}</span>
                {item.slot && <span className="italic opacity-70">{item.slot}</span>}
              </div>
              <div className="px-1.5 pb-1 text-[8px] text-muted-foreground leading-tight" style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                {item.effect}
              </div>
              <div className="px-1.5 pb-1 flex gap-1 text-[7px]">
                <span className="bg-muted/50 px-1 rounded text-muted-foreground">{item.value} PO</span>
                <span className="bg-muted/50 px-1 rounded text-muted-foreground">{item.weight} lb</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-2 flex items-center justify-center gap-1.5 text-[9px] text-muted-foreground/60">
        <Printer className="h-3 w-3" />
        <span>Cartes imprimables au format standard</span>
      </div>
    </div>
  );
}
